import type { IconData } from '@stacksjs/iconify-core'

export const trophyF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.294 15Q1.394 12.263 1 9Q.457 4.5 1 0h8q.466 4.993 0 9a32.7 32.7 0 0 1-1.287 6H8a2 2 0 0 1 2 2v3H0v-3a2 2 0 0 1 2-2zM3 16v2h4v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default trophyF
